import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import { Uris } from 'src/app/Services/public/Uris';
import { GlobalFunction } from 'src/app/Services/public/globalFunction';
import { Report, Sector } from '../interfaces/reports.interface';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  /* Seleccion de un solo reporte para el offsidebar o donde se necesite */
  private reportObservable = new BehaviorSubject<Report | null>(null);
  reportObservable$ = this.reportObservable.asObservable();

  /* list de reportes seleccionados */
  private ListreportsObservable = new BehaviorSubject<Report[]>([]);
  ListreportsObservable$ = this.ListreportsObservable.asObservable();

  /* Observable para crear un reporte con su sector  */
  private createReportObservable = new BehaviorSubject<Sector | null>(null);
  createReportObservable$ = this.createReportObservable.asObservable();

  /* Observable para obtener la ubicacion del puntero  */
  private positionReportObservable = new BehaviorSubject<{
    lat: number;
    lng: number;
  } | null>(null);
  positionReportObservable$ = this.positionReportObservable.asObservable();

  /* Observable para crear un reporte con su sector  */
  private viewPositionReportObservable = new BehaviorSubject<boolean>(false);
  viewPositionReportObservable$ =
    this.viewPositionReportObservable.asObservable();

  public areaReport:number = 0;

  constructor(
    private http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction
  ) {}
  setViewPositionReport(boolean) {
    this.viewPositionReportObservable.next(boolean);
  }
  setPositionReport(latLng: { lat: number; lng: number } | null) {
    this.positionReportObservable.next(latLng);
  }
  setSectorCreateReport(sector: Sector | null) {
    this.createReportObservable.next(sector);
  }
  setListReports(report: Report[]) {
    this.ListreportsObservable.next(report);
  }
  setReportObservable(report: Report | null) {
    this.reportObservable.next(report);
  }

  getReportsSector(query: string): Observable<Report[]> {
    return this.http
      .get<Report[]>(`${Uris.REPORTS}${query}`, this.globalFunction.headers())
      .pipe(
        map((resp: Report[]) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }
   getReportById(id:number): Observable<Report> {
    return this.http
      .get<Report>(`${Uris.REPORTS}${id}/`, this.globalFunction.headers())
      .pipe(
        map((resp: Report) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }
}
